module.exports = __webpack_public_path__ + "static/media/info-browser.d1198795.svg";